<template>
  <div class="buildings">
    <MobileTable
      v-model:selection="store.state.employee.selectedEmployees"
      :label="$route.name"
      :columns="employee.columns"
      :data="store.state.employee.employees"
    />
    <DesktopTable
      v-model:selection="store.state.employee.selectedEmployees"
      :label="$route.name"
      :columns="employee.columns"
      :data="store.state.employee.employees"
    />
    <Actions :items="employee.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/empleados/nuevo");
    };
    const onModify = () => {
      if (store.state.employee.selectedEmployees.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setOpenMode", openMode.MODIFY);
        router.push("/empleados/modificar");
      }
    };
    const onChangeStatus = async (status) => {
      if (!store.state.employee.selectedEmployees.length) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setLoading", true);

        const users = store.state.employee.selectedEmployees.map(
          (item) => item.userId
        );
        if (users.includes(store.state.auth.user.id)) {
          alert("No se puede modificar el usuario que ha iniciado sesión!");
          return;
        }

        const response = await store.dispatch(actions.employeeActions.status, {
          users,
          status,
        });

        if (response.ok) {
          store.commit("setSelectedEmployees", []);
          await store.dispatch(
            actions.employeeActions.findAll,
            store.state.auth.user.company
          );
          store.commit("setLoading", false);
        } else {
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
          store.commit("setLoading", false);
        }
      }
    };

    const employee = reactive({
      columns: [
        {
          field: "role",
          header: "Perfil",
        },
        {
          field: "name",
          header: "Nombre",
          sort: true,
        },
        {
          field: "identity",
          header: "Rut / CI",
        },
        {
          field: "email",
          header: "Email",
        },
        {
          field: "phone",
          header: "Teléfono",
        },
        {
          field: "active",
          header: "Habilitado",
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/empleados/nuevo"),
        },
        {
          name: "Modificar",
          action: onModify,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/empleados/modificar"),
        },
        {
          name: "Habilitar",
          action: () => onChangeStatus(true),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/empleados/modificar"),
        },
        {
          name: "Deshabilitar",
          action: () => onChangeStatus(false),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/empleados/modificar"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedEmployees", []);
      store.commit("setBreadcrumbs", [
        { label: "Inicio", to: "/home" },
        { label: route.name, to: route.path },
      ]);
      await store.dispatch(
        actions.employeeActions.findAll,
        store.state.auth.user.company
      );
      store.commit("setLoading", false);
    });

    return { store, employee };
  },
};
</script>

<style scoped></style>
